import { CoachingDifficulty } from './coaching';

/** Mirrors `@zhichetech/models` coaching progress (between practices). */

export enum CoachingMilestoneKind {
  FirstPractice = 'first_practice',
  FirstThreeStars = 'first_three_stars',
  FirstThreeStarsAdvanced = 'first_three_stars_advanced',
  FirstThreeStarsExpert = 'first_three_stars_expert',
  AreaSixty = 'area_60',
  AreaEighty = 'area_80',
  CriticalErrorAvoided = 'critical_error_avoided',
  FiveInAWeek = 'five_in_a_week',
  CaseImproved = 'case_improved',
}

export interface CoachingMilestoneView {
  id: string;
  kind: CoachingMilestoneKind;
  /** The area or case name, or the critical error left behind. */
  subject: string | null;
  attemptId: string;
  earnedAt: string;
}

export interface CoachingProfileArea {
  area: string;
  name: string;
  /** Null until a practice assessed it (还没练过). */
  score: number | null;
  attempts: number;
}

export interface CoachingProfileCase {
  caseId: string;
  title: string;
  difficulty: CoachingDifficulty;
  bestStars: number;
  practices: number;
}

export interface CoachingProfileView {
  areas: CoachingProfileArea[];
  cases: CoachingProfileCase[];
  /** Newest first. */
  milestones: CoachingMilestoneView[];
}

export const kCoachingWeeklyGoalMin = 1;
export const kCoachingWeeklyGoalMax = 7;

export interface CoachingStreakView {
  streak: number;
  practicedToday: boolean;
  weekPractices: number;
  weeklyGoal: number;
}

export interface CoachingLeaderboardEntry {
  rank: number;
  memberId: number;
  name: string;
  points: number;
  stars: number;
  practices: number;
}

export interface CoachingLeaderboardView {
  weekStart: string;
  top: CoachingLeaderboardEntry[];
  /** Null before the trainee's first practice this week. */
  own: CoachingLeaderboardEntry | null;
}
